
import rzIconDropArrow from '../../icons/icon-drop-arrow/index.vue';
import rzDropdown from '../dropdown/index.vue';
import ruFlag from './ru.png';
import enFlag from './en.png';
import kgFlag from './kg.png';
import mnFlag from './mn.png';

export default {
  name: 'rzLangSwitcher',
  components: {
    rzIconDropArrow, 
    rzDropdown,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    selectOptions: {
      type: Array,
      required: true,
    },
    short: {
      type: Boolean,
      default: false,
    },
    withoutArrow: {
      type: Boolean,
      default: false,
    },
    transitionName: {
      type: String,
      default: 'fade',
    },
  },
  data() {
    return {
      isDropdownOpened: false,
      selected: '',
      selectedIndex: 0,
      flags: {
        ru: ruFlag,
        kg: kgFlag,
        en: enFlag,
        mn: mnFlag,
      },
      names: {
        ru: 'Русский',
        kg: 'Кыргызча',
        en: 'English',
        mn: 'Монгол',
      }
    };
  },
  computed: {
    options() {
      return this.selectOptions.filter(option => option !== this.selected);
    },
  },
  watch: {
    value: {
      handler(value) {
        this.selected = value;
      },
      immediate: true,
    },
  },
  methods: {
    hideDropdown() {
      this.isDropdownOpened = false;
    },
    selectOption(option, index) {
      this.selected = option;
      this.selectedIndex = index;
      this.hideDropdown();
      this.$emit('input', option);
    },
  },
};
